import { JSX, PropsWithChildren, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { useRefurbishedShopEnabled } from "../../../common/hooks/useRefurbishedShopEnabled";

export const RefurbishedShopGuard = ({
    children,
}: PropsWithChildren): JSX.Element | null => {
    const navigate = useNavigate();
    const { refurbishedShopEnabled, isUserLoading } =
        useRefurbishedShopEnabled();

    useEffect(() => {
        if (isUserLoading) {
            return;
        }

        if (!refurbishedShopEnabled) {
            navigate(RouteEnum.PRODUCT_RANGE, { replace: true });
        }
    }, [refurbishedShopEnabled, isUserLoading, navigate]);

    if (isUserLoading) {
        return <>{children}</>;
    }

    if (!refurbishedShopEnabled) {
        return null;
    }

    return <>{children}</>;
};
